import { Link } from 'react-router-dom';
import { useI18n } from '@/contexts/I18nContext';
import { PageHead } from '@/components/layout/PageHead';
import { EmptyState } from '@/components/ui/EmptyState';
import { Button } from '@/components/shadcn/button';

export function NotFound() {
  const { t } = useI18n();
  return (
    <>
      <PageHead title="404" subtitle={t('not_found')} />
      <EmptyState
        title={t('not_found')}
        sub={t('not_found_sub')}
        action={
          <Button variant="outline" size="sm" asChild>
            <Link to="/dashboard">{t('back_to_dashboard')}</Link>
          </Button>
        }
      />
    </>
  );
}
